import { render, staticRenderFns } from "./PaginationPanel.vue?vue&type=template&id=a55d7530&scoped=true"
import script from "./PaginationPanel.vue?vue&type=script&lang=ts"
export * from "./PaginationPanel.vue?vue&type=script&lang=ts"
import style0 from "./PaginationPanel.vue?vue&type=style&index=0&id=a55d7530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55d7530",
  null
  
)

export default component.exports